import React, { Component } from "react";
import MainMenu from "./components/mainMenu";
import SubNavigation from "./components/subNavigation";
import TopBanner from "./components/topBanner";
import AnimatedBackground from "./components/animatedBackground";
import Footer from "./components/footer";
import SuitMaterial from "./components/suitMaterial";
import ImageCarousel from "./components/imageCarousel";
import SuitPlayer from "./components/3dPlayer";

export default class ClubSuits extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.title = "QwixSkinz || Ski Club Race Suits";
  }

  render() {
    return (
      <React.Fragment>
        <MainMenu />

        <TopBanner
          bannerHeight="full"
          title="Ski Club Race Suits"
          description="All details have been fully considered to take the Qwixskinz name from the World Cup circuit to the ski club slopes."
          images={[
            "clubsuit/ski-club-youth-race-suit.jpg",
            "clubsuit/qwixskinz-alpine-ski-club-suit.jpg"
          ]}
        />

        <SubNavigation
          location={this.props.location}
          refs={this.refs}
          navItems={[
            { title: "Downhill Race Suit", id: "downhill" },
            { title: "Our Designs", id: "ourDesigns"},
            { title: "Giant Slalom Race Suit", id: "giantslalom" },
            { title: "Under Suits", id: "under-suit" },
            { title: "Warm Up Shorts", id: "warmup-short" },
            { title: "Material", id: "material" }
          ]}
        />

        <div className="qs-b" ref="downhill">
          <div className="container block-wrap behind-mnt1">
            <div className="d-flex flex-row flex-wrap align-items-stretch">
              <div className="col-12 content dark pb-0">
                <div className="section-title">
                  <h1 className="title">Downhill Race Suit</h1>
                </div>
              </div>

              <div className="col-12 col-md-6 content dark pt-0">
                <p className="lead">
                  All details have been fully considered to take the Qwixskinz
                  name from the World Cup circuit to the ski club slopes.
                </p>
                <p>
                  The Qwixskinz Ski Club DownHill (DH) Race suit provides the
                  high quality race suit option missing for the ski club world.
                  We took our best race suit &amp; fabric details &amp; put them into
                  our ski club DH race suit. The industry expected 3 layer
                  fabric system has been modified &amp; improved using AirTek
                  technology to culminate in a superior fabric line exclusive to
                  Qwixskinz. Our fabrics not only provide the distinct
                  characteristics for each discipline &amp; level but also a
                  superior abrasion resistant top layer that retains vibrant
                  prints longer and provides protection against piling, a
                  targeted problem we sought to solve.
                </p>
                <p>
                  Articulated pattern development, using our new 3D patterning
                  technology provides the best fit for the racing position with
                  gripper elastic keeping the suit leg tight to the boot.
                  Durable YYK zipper &amp; fabric zipper flap provide long lasting
                  zipper life as well as all-important wind protection.
                  Integrated ski pass pocket in the chest allows for quick &amp;
                  easy lift access.
                </p>

                <h3 className="fis-approved">Adult DH FIS Approved</h3>
                <p>
                  Our FIS-Approved DH Race Suit will have the look &amp; performance
                  rivaling the World Cup race suits produced by Qwixskinz. The
                  mid-layer of our AirTek technology allows the FIS-Approved air
                  flow &amp; all race suits have the FIS required label.
                </p>

                <h3>Adult DH Non-FIS Approved</h3>
                <p>
                  Using the same high quality, aerodynamic AirTek fabric
                  exclusive to QwixSkinz as our FIS rated race suit, our Non-FIS
                  rated DH race suit allows for an added layer of comfort the
                  reduced air permeability allows. Our mid-layer of our non-FIS
                  approved suits offers the added wind &amp; water protection to
                  it’s aerodynamic attributes.
                </p>
                <p>
                  When a FIS-rating is not required, our Qwixskinz DH Non-FIS
                  race suit delivers the same high quality our athletes expect.
                  Our 3D pattern technology provides the superior quality of fit
                  to the DH Non-FIS race suit.
                </p>

                <h3>Youth DH Non-FIS</h3>
                <p>
                  The youth racer has the benefit of the same Qwixskinz quality
                  that the adult DH suits provide. With the FIS-rating not being
                  required we can concentrate on the other performance
                  components of our youth race suit. The superior abrasion
                  resistant top layer of our exclusive AirTek line of fabrics is
                  especially important for the younger racers. The mid-layer
                  provides the wind &amp; water protection &amp; with the inner fabric
                  layer specifically designed to provide added warmth, keeping
                  the young racers happier on the hill.
                </p>
                <p>
                  Our Youth Downhill (DH) Race Suit can be an option when
                  padding is not required.
                </p>
              </div>
              <div className="col-12 col-md-6">
                <div className="">
                  <ImageCarousel
                    className="large-media sticky"
                    images={[
                      "/images/suits/club/qwixskinz-custom-race-suit.jpg",
                      "/images/suits/club/aaron-orange-alpine-ski-club-suit.jpg",
                      "/images/suits/club/Ski-Club-Suit-youth.jpg",
                      "/images/suits/club/broderick-thompson-alpine-race-suit.jpg",
                      "/images/suits/club/d-cook-super-g-alpine-race-suit.jpg",
                      "/images/suits/club/alpine-ski-speed-suit.jpg",
                      "/images/suits/club/alpine-ski-speed-suit-2.jpg",
                      "/images/suits/club/Manuel-Osborne-Paradis.jpg"
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="qs-b" ref="ourDesigns">

          <div className="container block-wrap behind-mnt1">
          <div className="col-12 content dark pb-0">
          <div className="section-title">
            <h1 className="title">Our Designs</h1>
            <p>Choose your favourite design &amp; contact us to customize colours &amp; logos for you order</p>

            <h4 className="green">Erik Guay <span className="special-edition" >Special Edition</span> Race Suit</h4>
            <div className="quote-block">
              <p className="quote-text">"I’ve trusted Qwixskinz throughout my career, especially the race suit innovation I relied on in my 2017 St Moritz World Championships gold & silver medal races! The fit and the fabric are always next level! This is why I am proud to team up with Qwixskinz to develop my own race suit design for the next generation of champions!"</p>


              {/* <figure>
                <img src="/images/erik/erikGuayProfile.jpg" style={{ borderRadius: "100%" }} alt="Erik Guay"/>
                <figcaption>
                  <span className="quote-author">Erik Guay</span>
                  <span className="quote-author-title">The Most Decorated Canadian <br/>Alpine Ski Racer in History</span>
                </figcaption>
              </figure> */}
            </div>

            <div>
              <h5>How to do you honour a <span className="green">LEGENDARY</span> Ski Racing Career? We think we have found the answer to that question!</h5>
<p>Erik had a design concept that we brought to reality with this Erik Guay Special Edition Race Suit. The slashes of yellow & the yellow Maple Leaf pay homage to the traditional yellow Canadian race suits Erik wore to many medals. ALL of his career podium finishes are superimposed into the background so you can wear Erik's ski racing excellence in your pursuit of your own ski racing history!!
<br/>Deanna Panting CEO Qwixskinz Inc.</p>
            </div>

            <div className="suit-container">
              <div className="suit-main">
              <img alt="Erik Guay Special Edition Suit Red" src="/images/erik/erikGuaySuitRed.png"/>
              </div><div className="suit-options">
                <img alt="Erik Guay Special Edition Suit Blue" src="/images/erik/erikGuaySuitBlue.png"/>
                <img alt="Erik Guay Special Edition Suit Pink" src="/images/erik/erikGuaySuitPink.png"/>
                <img alt="Erik Guay Special Edition Suit Green" src="/images/erik/erikGuaySuitGreen.png"/>
              </div>
            </div>

          </div>
          </div>
          <div className="d-flex align-items-center justify-content-around flex-wrap">
          <SuitPlayer
            posterSrc={"/videos/ErikSE_Poster.png"}
            videoSrc={[
              { src: "/videos/ErikSE.webm", type: "video/webm" },
              { src: "/videos/ErikSE.mp4", type: "video/mp4" }
            ]}
            suitName="Erik Guay Special Edition"
          />
            <SuitPlayer
              posterSrc={"/videos/Avenger_poster.png"}
              videoSrc={[
                { src: "/videos/Avenger_800k.webm", type: "video/webm" },
                { src: "/videos/Avenger.mp4", type: "video/mp4" }
              ]}
              suitName="Avenger"
            />
            <SuitPlayer
              posterSrc={"/videos/Bolt_poster.png"}
              videoSrc={[
                { src: "/videos/Bolt_800k.webm", type: "video/webm" },
                { src: "/videos/Bolt.mp4", type: "video/mp4" }
              ]}
              suitName="Bolt"
            />
            <SuitPlayer
              posterSrc={"/videos/NorthernLights_poster.png"}
              videoSrc={[
                {
                  src: "/videos/NorthernLights_800k.webm",
                  type: "video/webm"
                },
                { src: "/videos/NorthernLights.mp4", type: "video/mp4" }
              ]}
              suitName="Northern Lights"

            />
          </div>
          <div className="d-flex align-items-center justify-content-center flex-wrap w-100">

              <a className="btn btn-primary m-2" target="_blank" href="/pdf/Alpine_Ski_Mens_Size_Chart.pdf?v=2">Men's Size Chart</a>
              <a className="btn btn-primary m-2" target="_blank" href="/pdf/Alpine_Ski_Womens_Size_Chart.pdf">Women's Size Chart</a>
              <a className="btn btn-primary m-2" target="_blank" href="/pdf/Alpine_Youth_Race_Suit_Size_Chart.pdf">Youth  Size Chart</a>
              <a className="btn btn-primary m-2" target="_blank" href="/pdf/MASTER_PRICE_LIST_Ski_Clubs_2019.pdf">Price List</a>

          </div>
          </div>

        </div>


        <div className="qs-b" ref="giantslalom">
          <div className="container block-wrap behind-mnt1">
            <div className="d-flex flex-row flex-wrap align-items-stretch">
              <div className="col-12 content dark pb-0">
                <div className="section-title">
                  <h1 className="title">Giant Slalom Race Suit</h1>
                </div>
              </div>
              <div className="col-12 content dark pt-0">
                <p className="lead">
                  All details have been fully considered to take the Qwixskinz
                  name from the World Cup circuit to the club race suit slopes.
                </p>
                <p>
                  The Qwixskinz Padded Giant Slalom (GS) race suits is a
                  superior ski club suit option. Our AirTek 3 layer fabric
                  system, developed for &amp; exclusive only to Qwixskinz will have
                  the look &amp; performance rivaling our World Cup race suits. An
                  abrasion resistant top layer of fabric gives the best
                  protection against pilling or deterioration of the fabric
                  surface even when hitting the gates.
                </p>
                <p>
                  Our GS race suits have also benefited from our new 3D pattern
                  technology, taking our race position fit to a new level we
                  feel ski club racers deserve.Silicone gripper elastic at the
                  leg edge keep the suit leg in place. Durable YYK zippers &amp;
                  fabric zipper flaps give wind protection in the cold.
                  Strategically placed GS padding uses a composite foam
                  specifically developed for the Qwixskinz ski club collection.
                </p>

                <h3 className="fis-approved">Adult (GS-Padded) FIS Approved</h3>
                <p>
                  Our Adult Giant Slalom (GS-Padded) FIS-Approved race suit
                  provides the Qwixskinsz quality the pros rely one. Our
                  mid-layer in our exclusive AirTek fabric allows for the FIS
                  approved air flow &amp; all suits have the required FIS label.
                </p>

                <h3>Adult (GS-Padded) Non-FIS Approved</h3>
                <p>
                  Qwixskinz is offering Non-FIS rated Adult Padded GS race suits
                  as a ski club, development &amp; university suit option. The
                  mid-layer of our non-FIS rated suits offers the added comfort
                  of wind &amp; water protection to it’s attributes. The superior
                  abrasion resistant top layer of our exclusive AirTek fabric
                  has been developed to withstand the wear &amp; tear GS racing
                  throws at a race suit. Strategically placed, articulated GS
                  padding uses a composite foam specifically developed for the
                  Qwixskinz ski club collection.
                </p>

                <h3>Youth (GS-Padded) Non-FIS</h3>
                <p>
                  The youth racer has the benefit of the same Qwixskinz quality
                  that the adult suits provide. The mid-layer provides the wind
                  &amp; water protection &amp; with the inner fabric layer specifically
                  designed to provide added warmth, the young racers will be
                  kept happier on the hill. Our exclusive AirTek fabric
                  developed for this category of race suit has been specifically
                  designed for the challenges of youth GS racing. A simplified
                  padding system allows for a more uniform protection for the
                  smaller racer.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="qs-b" ref="under-suit">
          <div className="container block-wrap behind-mnt1">
            <div className="d-flex flex-row flex-wrap align-items-stretch">
              <div className="col-12 content dark pb-0">
                <div className="section-title">
                  <h1 className="title">Alpine Ski Race Under Suits</h1>
                </div>
              </div>
              <div className="col-12 col-md-6 content dark pt-0">
                <h3 className="fis-approved">
                  Alpine Ski 2<sup>nd</sup>SKINZ Under Suit - FIS Approved
                </h3>
                <p className="lead">
                  The same aerodynamic concept &amp; science behind those worn by
                  World Champion &amp; World Cup winners is available in our
                  Qwixskinz FIS approved 2<sup>nd</sup>SKINZ.
                </p>
                <p>
                  Our technical fabric combines with your race suit air
                  permeability to increase the aerodynamic features &amp; decrease
                  your aerodynamic drag. Strategic flat seaming &amp; edges allow
                  for the perfect fit under your race suit. It’s like a second
                  skin…only better.
                </p>
              </div>
              <div className="col-12 col-md-6 content dark pt-0">
                <h3>Alpine Ski ThermoSKINZ Under Suit - Non FIS Rated</h3>
                <p className="lead">
                  When air permeability ratings are not a consideration, our
                  Qwixskinz ThermoSKINZ keeps you warm so you can concentrate on
                  your run.
                </p>

                <p>
                  With just the right amount of thickness, it doesn’t add bulk
                  while providing wind &amp; moisture protection. For training runs
                  on those cold winter days or race days for the youth skier who
                  doesn’t need FIS rated suits. Our ThermoSKINZ fabric’s soft
                  fleeced inside layer is comfortable against your skin while
                  the middle membrane provides long lasting wind &amp; moisture
                  protection.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="qs-b" ref="warmup-short">
          <div className="container block-wrap behind-mnt1">
            <div className="d-flex flex-row flex-wrap align-items-stretch">
              <div className="col-12 content dark pb-0">
                <div className="section-title">
                  <h1 className="title">Alpine Ski Club Warm Up Short</h1>
                </div>
              </div>

              <div className="col-12 col-md-6 content dark pt-0">
                <p className="lead">
                  A must for the warm up and training runs.
                </p>

                <p>
                  The Qwixskinz Alpine Warm-Up short has been preferred by our
                  WC teams that have tried the alternatives.
                </p>
                <ul>
                  <li>
                    High quality, articulated short panels that allow for
                    club/team customization on the Left Leg side panel with
                    custom printed colour &amp; logo. Also available in our standard
                    Qwixskinz design for individual orders.
                  </li>
                  <li>
                    Adjustable suspenders for the perfect fit that won’t ride
                    down. -Lower back comfort panel to keep the warmth in &amp; the
                    cold air out.
                  </li>
                  <li>
                    Abrasion resistant fabric with just the right amount of
                    stretch for ease of movement. Fleece backed for added warmth
                    on the warm up runs. Dye sublimated side panels in the same
                    abrasion resistant fabric that keeps colours vibrant &amp; new
                    looking longer.
                  </li>
                  <li>
                    Dual leg zippers with zipper flaps for wind protection.
                  </li>
                </ul>

                <p>Available in Adult &amp; Youth Sizes.</p>
              </div>
              <div className="col-12 col-md-6">
                <div className="">
                  <img src="images/suits/club/qwixskinz-alpine-ski-warm-up-shorts.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Material Science Section */}
        <SuitMaterial ref="material">
          <div className="section-title">
            <h1 className="title">Material Science</h1>
          </div>
          <p className="lead">
            Qwixskinz has developed our Alpine Ski Club race suit line with an
            exclusive AirTek fabric line that provides superior performance both
            in aerodynamics and performance as well as the durability required
            in all stages of development ski racing.
          </p>
          <img
            src="images/logo/SVG/AirTekLogo.svg"
            style={{ width: "50%" }}
            className="pt-1 mx-auto d-block"
          />
        </SuitMaterial>

        {/* Performace Section */}
        <div className="qs-b" ref="performance">
          <div className="container block-wrap behind-trees">
            <div className="d-flex flex-row flex-wrap align-items-stretch">
              <div className="col-12 content dark pb-0 text-center">
                <div className="section-title">
                  <h1 className="title">Performance Benefits</h1>
                </div>
              </div>

              <div className="col-12 content dark pt-0">
                <img src="images/research/alpine-ski-race-suit-fabric-testing.jpg" />
              </div>
            </div>
          </div>
        </div>

        <Footer />

        <AnimatedBackground />
      </React.Fragment>
    );
  }
}
